import { DisplayEventsEventNoProducts } from '@shopby/shop-sdk';
import React from 'react';
import { isMobile } from 'react-device-detect';
import { MultiLevelCategoryItem } from '../../@types/exhibition';

interface SliceItemProps {
  data?: MultiLevelCategoryItem;
  imageHeight?: number;
  isTouchMoving: boolean;
  findSelectedCategoryItem?: MultiLevelCategoryItem;
  onChangeCategory: (data: MultiLevelCategoryItem) => void;
  setProductList: React.Dispatch<React.SetStateAction<DisplayEventsEventNoProducts[]>>;
  setPage: React.Dispatch<React.SetStateAction<number>>;
  setCategoryNo: React.Dispatch<React.SetStateAction<number>>;
}

const SliceItem: React.FC<SliceItemProps> = ({
  data,
  imageHeight,
  isTouchMoving,
  findSelectedCategoryItem,
  onChangeCategory,
  setProductList,
  setPage,
  setCategoryNo,
}) => {
  return (
    <div className={data?.categoryNo === findSelectedCategoryItem?.categoryNo ? 'on' : ''}>
      <a
        className="all"
        onTouchEnd={(e) => {
          e.preventDefault();
          if (isMobile && !isTouchMoving && data) {
            onChangeCategory(data);
            window.scrollTo(0, Number(imageHeight));
            setPage(0);
            setProductList([]);
            setCategoryNo(data?.categoryNo || 0);
          }
        }}
        onClick={(e) => {
          e.preventDefault();
          if (!isMobile && data) {
            onChangeCategory(data);
            window.scrollTo(0, Number(imageHeight));
            setPage(0);
            setProductList([]);
            setCategoryNo(data?.categoryNo || 0);
          }
        }}
        key={data?.categoryNo}
      >
        {data?.label}
      </a>
    </div>
  );
};

export default SliceItem;
